import { useEffect, useState } from 'react';
import { useLeague } from './useLeague';

type TimeState = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  finished: boolean;
};

type LeagueSeasonTimerType = {
  timeRemaining: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
    finished: boolean;
  };
};

export const useLeagueSeasonTimer = (): LeagueSeasonTimerType => {
  const { currentSeason } = useLeague();
  const [timeRemaining, setTimeRemaining] = useState<TimeState>({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    finished: false,
  });

  useEffect(() => {
    if (!currentSeason?.endDate) return;

    const getEndTimestamp = (): number => {
      const end: any = currentSeason.endDate;

      if (end?.seconds) {
        return end.seconds * 1000;
      }

      return new Date(end).getTime();
    };

    const getTimeRemaining = (): TimeState => {
      const now = Date.now();
      const end = getEndTimestamp();

      const diff = end - now;

      if (diff <= 0) {
        return {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
          finished: true,
        };
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      return {
        days,
        hours,
        minutes,
        seconds,
        finished: false,
      };
    };

    const interval = setInterval(() => {
      setTimeRemaining(getTimeRemaining());
    }, 1000);

    setTimeRemaining(getTimeRemaining());

    return () => clearInterval(interval);
  }, [currentSeason]);

  return {
    timeRemaining,
  };
};
